import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import CustomIcon from './CustomIcon'

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9'
    }
}))(Tooltip);

export default function CustomizedTooltips({ tooltip, hover, placement = 'bottom', style = {}, iconColor = '#A7A7A8' }) {
    const [isOpen, setOpened] = React.useState(false)

    const onClose = () => {
        if (hover) return
        setOpened(false)
    }

    const onOpen = () => {
        if (hover) return
        setOpened(true)
    }

    const props = React.useMemo(() => {
        if (hover) return {}
        else {
return {
            open: isOpen,
            disableFocusListener: true,
            disableHoverListener: true,
            disableTouchListener: true
        }
}
    }, [hover, isOpen])
    return (
        <ClickAwayListener onClickAway={onClose}>
            <HtmlTooltip
                placement={placement}
                onClose={onClose}
                {...props}
                title={
                    <React.Fragment>{tooltip}</React.Fragment>
                }
            >
                <IconButton onClick={onOpen} style={style}>
                    <CustomIcon name='Help' color={iconColor} style={{ width: 16, height: 16 }} />
                </IconButton>
            </HtmlTooltip>
        </ClickAwayListener>
    );
}
